import CMSService from '@/domain/CMS/services/cms'
import { CMS, ContentTypes } from 'stoux-shared-types/models/cms'

export default async function getStaticHomeContent(store: string | null) {
    const DEFAULT_BANNER: Partial<CMS> = {
        id: '',
        deleted_at: null,
        type: 'HERO_BANNER' as ContentTypes,
        metadata: {
            title: 'Rien ne se perd, rien ne se crée, tout se revend',
            content:
                "Du collectionneur au passionné occasionnel, Stoux est l'endroit pour trouver votre trésor. Rejoignez-nous dans cette aventure !",
            url: '/search',
            button_text: 'Découvrir',
        } as any,
        resource_url: '/images/banners/hero.png',
    }

    try {
        const { resources } = await CMSService.list()
        let banner: CMS | undefined = resources.find(
            (resource) => resource.type === 'HERO_BANNER',
        )

        if (!banner) {
            banner = DEFAULT_BANNER as any
        }

        return { banner }
    } catch (error) {
        console.error(error)
        return {
            banner: DEFAULT_BANNER,
        }
    }
}

export async function getBranding(store: string | null) {
    const DEFAULT_BRANDING = {
        primaryColor: '#22c55e',
        primaryColorLight: '#22c55e10',
        primaryColorDark: '#15803d',
        btnColor: '#22c55e',
        btnColorHover: '#15803d',
    }

    try {
        const { resources } = await CMSService.list()
        const branding = resources.find(r => r.type === 'BRANDING')
        return { branding: (branding?.metadata as any) ?? DEFAULT_BRANDING }
    } catch {
        return { branding: DEFAULT_BRANDING }
    }
}